export default "__VITE_ASSET__4e38dc6f__"